import { render, staticRenderFns } from "./BeneficiariosIndex.vue?vue&type=template&id=db7c791c"
import script from "./BeneficiariosIndex.vue?vue&type=script&lang=js"
export * from "./BeneficiariosIndex.vue?vue&type=script&lang=js"
import style0 from "./BeneficiariosIndex.vue?vue&type=style&index=0&id=db7c791c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSimpleTable})
